import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api/bwm',
  headers: { 'x-api-key': process.env.REACT_APP_API_KEY || '' },
});

export const uploadImage = (file, token) => {
  const form = new FormData();
  form.append('file', file);
  return api
    .post('/upload', form, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => r.data.url);
};
